var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E6EAEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7209 21.1108V19.6442L18.0412 12.8182H19.2642V14.9062H18.5185L15.6101 19.5149V19.5945H21.6406V21.1108H13.7209ZM18.5781 23V20.6634L18.598 20.0071V12.8182H20.3381V23H18.5781Z",
    fill: "#222324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e4f779090c74c91aae2e0a869d9980d3.svg";
export { ForwardRef as ReactComponent };